import React, { useEffect } from "react";
import ScoresTemplate from "../../Templetes/Scores/Scores.template";

const ScoresPage = () => {
  useEffect(() => {
    document.title = "International Robot Challenge - Scores";
  }, []);
  return <ScoresTemplate />;
};

export default ScoresPage;


